import { debug, observer, React, RouteComponentProps } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { ISigningResponse } from "types/signing";
import { SigningComponent } from "../signing/views/SigningComponent";
import { BSPOptionsRoutes } from "./BSPOptionsRoutes";
import { BSPOptionsStore } from "./BSPOptionsStore";
import { BSPOptionsPayoutSummarySection } from "./components/BSPOptionsPayoutSummarySection";
import { BSPOptionsSummarySection } from "./components/BSPOptionsSummarySection";


type IProps = RouteComponentProps<{}> & {
    store: BSPOptionsStore;
};

@observer
export class BSPOptionsSigning extends React.Component<IProps, {}> {
    render() {
        console.log("### signing");
        return (
            <SigningComponent
                useWebVersion
                signingInfo={this.props.store?.signInfo}
                content={this.props.store.selectedPayout ? <BSPOptionsPayoutSummarySection store={this.props.store} style={{ padding: 32 }} /> : <BSPOptionsSummarySection store={this.props.store} style={{ padding: 32 }} />}
                onSuccess={(response: ISigningResponse) => {
                    debug.log("### signing success", response);
                    pushRoute(BSPOptionsRoutes.SUCCESS);
                }}
                onRetry={async () => {
                    this.props.store.selectedPayout ? await this.props.store.postPayout() : await this.props.store.postProlongation();
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/BSPOptions/BSPOptionsSigning.tsx